import React from "react"
import { Modal } from "@mimber/ui-web"
import { EditTaxRateForm } from "@/components/forms/EditTaxRateForm"
import type { EditTaxRateModalProps } from "./EditTaxRateModal.types"

/**
 * Modal component for editing organization tax rates
 * Uses the ui-web Modal wrapper with render props pattern
 */
export const EditTaxRateModal: React.FunctionComponent<
  EditTaxRateModalProps
> = ({ taxRate, onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Edit Tax Rate" {...modalProps}>
      {(close) => (
        <EditTaxRateForm
          taxRate={taxRate}
          onSuccess={(updatedTaxRate) => {
            close()
            onSuccess?.(updatedTaxRate)
          }}
        />
      )}
    </Modal>
  )
}
